package io.eqoty.shared.ui.utils

enum class BootstrapBreakpoint(val px: Int) {
    Sm(576),
    Md(768),
    Lg(992),
    Xl(1200),
    Xxl(1400)
}